import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaginationModel } from 'src/app/models/paginationModel';
import { ApiService } from 'src/app/api.service';

@Component({
    selector: 'app-agents-in-field',
    templateUrl: './agents-in-field.component.html',
    styleUrls: ['./agents-in-field.component.css'],
    providers: [NgxSpinnerService]
})
export class AgentsInFieldComponent implements OnInit {
    displayedColumns: string[] = ['profileFullName', 'email', 'inField', 'role'];
    dataSource = new MatTableDataSource<any>();
    totalLength = 0;
    active = "ProfileFullName";
    direction = "ASC";
    pageIndex = 0;
    pageSize = 5;
    filter = "";
    inField = 2;
    filterApplied = false;
    scrHeight: any;
    scrWidth: any;
    roles: Array<{name:string}> = [
        {name: "SecurityAgent"},
        // {name: "Owner"},
        {name: "Supervisor"}
    ];
    rFilter = "select_role";
    roleFilter = "select_role";

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor(
        private apiService: ApiService, 
        public functionsService:FunctionsService, 
        public translate:TranslateService,
        private spinner: NgxSpinnerService,
        public pagination: PaginationModel
    ) { 
        this.functionsService.setTitle('setting.agents_in_field');
    }

    ngOnInit(): void {
        this.getScreenSize();
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.translate.onLangChange.subscribe(() => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
        });
        this.fetchUsers();
    }

    private fetchUsers() {
        if(!this.filterApplied){
            this.clearFilter();
        }
        this.spinner.show();
        this.pagination.Page = this.pageIndex;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy = this.active;
        this.pagination.Order = this.direction;
        this.pagination.Filter = this.filter;
        this.pagination.Role = this.rFilter;
        this.pagination.Status = this.inField;
        this.apiService.getAgentsInField(this.pagination).subscribe(resp => {
            this.dataSource.data = Object.values(resp)[0];
            this.totalLength = parseInt(Object.keys(resp)[0]);
            
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.spinner.hide();
        }, error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        });
    }

    nextPage(evt){
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.fetchUsers();
    }

    sortData(evt){
        this.active = evt.active;
        this.direction = evt.direction;
        this.fetchUsers();
    }

    changeRoleLabel(role: string) {
        this.rFilter = role;
        this.roleFilter = role;
    }

    statusObject = {"active":1, "inactive":0};
    statusFilter: string = "select_status";
    statuses: string[] = Object.keys(this.statusObject);
    changeStatusFilterLabel(status) {
        this.statusFilter = status;
        this.inField = this.statusObject[status];
    }

    applyFilter() {
        this.pageIndex = 0;
        this.filter = (<HTMLInputElement>document.getElementById("filter")).value;
        this.filter = this.filter.trim().toLowerCase();
        this.filterApplied = true;
        this.fetchUsers();
    }

    clearFilter(){
        this.filter = "";
        this.rFilter = "select_role";
        this.roleFilter = "select_role";
        this.inField = 2;
        this.statusFilter = "select_status";
        if((<HTMLInputElement>document.getElementById("filter"))){
            (<HTMLInputElement>document.getElementById("filter")).value = "";
        }
    
        if(this.filterApplied){
            this.filterApplied = false;
            this.fetchUsers();
        }
    }

    emptyInput(){
        if((<HTMLInputElement>document.getElementById("filter")).value == ""){
            this.filter = "";
            this.fetchUsers();
        }
    }

    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['profileFullName', 'email', 'inField', 'role'];
        
        if(this.scrWidth <= 375){
            this.displayedColumns = ['profileFullName'];
        }
        else if(this.scrWidth <= 440){
            this.displayedColumns = ['profileFullName', 'email'];
        }
        else if(this.scrWidth <= 600){
            this.displayedColumns = ['profileFullName', 'email', 'inField', 'role'];
        }
    }
}